<script setup lang="ts">
const props = defineProps({
  tableProps: {
    type: Object,
    default: function () {
      return {
        striped: false,
        hover: false,
        stripedColumns: false,
        shadowOff: false
      }
    }
  }
})
</script>
<template>
  <main>
    <CRow>
      <CCol>
        <CCard class="mb-4" :class="{ 'shadow-none': tableProps?.shadowOff, 'border-0': tableProps?.shadowOff }">
          <CCardBody class="p-4">
            <CRow>
              <CCol>
                <CCardTitle class="fs-4 fw-semibold text-center"><CSpinner color="dark" /></CCardTitle>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </main>
</template>
